import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';

const TagTooltipContainer = ({ className, children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const sendEvent = (data) => dispatch(analyticsActions.sendEvent(data));
    sendEvent(analyticsEvents.priceBreakdownXDockTagHover());
  }, [dispatch]);

  return <div className={className}>{children}</div>;
};

export default TagTooltipContainer;
